import { render, staticRenderFns } from "./TradeWidget.vue?vue&type=template&id=c9381658&scoped=true"
import script from "./TradeWidget.vue?vue&type=script&lang=js"
export * from "./TradeWidget.vue?vue&type=script&lang=js"
import style0 from "./TradeWidget.vue?vue&type=style&index=0&id=c9381658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9381658",
  null
  
)

export default component.exports